// gruppi.ts — la partita a 4 (v013): chiamate HTTP (crea, info, entra, server video) e i token dei posti salvati sul
// telefono, così ricaricando la pagina si rientra nel proprio posto.
import { richiesta } from "./api.ts";
import { idDispositivo } from "./dispositivo.ts";
import { avatarAttuale } from "./account.ts";
import { leggiPreferenza, salvaPreferenza } from "./preferenze.ts";
import type { ServerIce } from "./sfide.ts";
import { PERCORSO_GRUPPO, PREFERENZE } from "../costanti.ts";
import { indirizzoSito } from "../gioco/Condividi.tsx";

export type StatoGruppo = "aperto" | "in_corso" | "chiuso";
export interface InfoGruppo {
  stato: StatoGruppo;
  posti: number;
  massimo: number;
  organizzatore: string | null;
  /** v020 */
  avatarOrganizzatore?: number | null;
}

const enc = encodeURIComponent;

export function creaGruppo(nome: string, conBot = false): Promise<{ codice: string; token: string; link: string; posto: number }> {
  return richiesta("/api/v1/gruppi", { metodo: "POST", corpo: { nome, dispositivo: idDispositivo(), avatar: avatarAttuale(), ...(conBot ? { conBot: true } : {}) } });
}
export function leggiGruppo(codice: string): Promise<InfoGruppo> {
  return richiesta(`/api/v1/gruppi/${enc(codice)}`);
}
export function entraGruppo(codice: string, nome: string): Promise<{ token: string; posto: number }> {
  return richiesta(`/api/v1/gruppi/${enc(codice)}/entra`, { metodo: "POST", corpo: { nome, dispositivo: idDispositivo(), avatar: avatarAttuale() } });
}
/** v041: il tester che organizza mette un bot nel primo posto vuoto. */
export function aggiungiBotGruppo(codice: string, token: string): Promise<{ posto: number }> {
  return richiesta(`/api/v1/gruppi/${enc(codice)}/bot`, { metodo: "POST", corpo: { token } });
}
export function serverIceGruppo(codice: string, token: string): Promise<{ iceServers: ServerIce[]; turn: boolean }> {
  return richiesta(`/api/v1/gruppi/${enc(codice)}/ice`, { metodo: "POST", corpo: { token } });
}
export function segnalaGruppo(codice: string, token: string, posto: number, motivo: string, nota: string): Promise<void> {
  return richiesta(`/api/v1/gruppi/${enc(codice)}/segnala`, {
    metodo: "POST",
    corpo: { token, posto, motivo, ...(nota.trim() ? { nota: nota.trim() } : {}) },
  });
}
export const linkGruppo = (codice: string): string => `${indirizzoSito()}${PERCORSO_GRUPPO}${codice}`;

// --- sul telefono -----------------------------------------------------------------------
// Un gruppo dura al massimo attesa + durata massima (fino a 2 giorni con i massimi del pannello): dopo 3 giorni i token
// non servono più.
const DURATA_MS = 3 * 24 * 3600 * 1000;
type Salvati = Record<string, { token: string; il: number }>;

function salvati(): Salvati {
  try {
    const v = JSON.parse(leggiPreferenza(PREFERENZE.gruppi) ?? "{}") as Salvati;
    return typeof v === "object" && v !== null ? v : {};
  } catch {
    return {};
  }
}
export function tokenGruppo(codice: string): string | null {
  return salvati()[codice]?.token ?? null;
}
export function salvaTokenGruppo(codice: string, token: string): void {
  const ora = Date.now();
  const s = Object.fromEntries(Object.entries(salvati()).filter(([, v]) => ora - v.il < DURATA_MS));
  s[codice] = { token, il: ora };
  salvaPreferenza(PREFERENZE.gruppi, JSON.stringify(s));
}
export function dimenticaGruppo(codice: string): void {
  const s = salvati();
  delete s[codice];
  salvaPreferenza(PREFERENZE.gruppi, JSON.stringify(s));
}
